import { siteGeometryStore } from "../store";

export function invalidateSiteLayerData() {
  setTimeout(() => {
    siteGeometryStore.changeCount++;
  }, 0);
}
